module.exports = __webpack_public_path__ + "components/patterns/collectionObjectHeaderArea/collection-object-header-area.tpl.php";